export default __webpack_public_path__ + "static/media/image5.d2275131.png";